var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workspaceGroupTitle",class:_vm.size},[_c('span',{staticClass:"workspaceGroupTitle__title",style:({ width: (_vm.maxWidth + "px") })},[_vm._v(_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }